import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import ActivityCreator from "../../../../components/ActivityCreator";
import Breadcrumb from "../../../../components/Breadcrumb";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import {
  MINHAS_TRILHAS_PATH,
  TRILHA_BREADCRUMB_CADASTRO,
  TRILHA_BREADCRUMB_LISTAGEM,
  isTrailQueryActive
} from "../../../../config/minhasTrilhas";

const ActivityCreate = props => {
  const isTrail = isTrailQueryActive(props.location?.search);

  return (
    <div className="container">
      <Breadcrumb
        current={props.currentRoute}
        currentName={isTrail ? TRILHA_BREADCRUMB_CADASTRO : undefined}
        items={[
          isTrail
            ? {
                path: "/activity/list",
                to: MINHAS_TRILHAS_PATH,
                name: TRILHA_BREADCRUMB_LISTAGEM
              }
            : { path: "/activity/list", to: "/activity/list" }
        ]}
      />
      <ActivityCreator {...props} />
      <ProtectedRoute routeId={props.currentRoute} />
    </div>
  );
};

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ActivityCreate);
